/* jshint esversion: 6 */
import React from 'react';
import SocialPanelModule from 'app/mixins/SocialPanelModule.js';
import { Link } from 'react-router-dom';

class DiscordOptions extends React.Component {
    render() {
        let currentPanel = null,
            optionFields = null,
            postTitle = !!parseInt(this.props.getParamValue('postTitle'), 10),
            postBody = !!parseInt(this.props.getParamValue('postBody'), 10),
            postUrl = !!parseInt(this.props.getParamValue('postUrl'), 10),
            postImages = !!(parseInt(this.props.getParamValue('postImages'), 10)),
            prefixSpace = !!parseInt(this.props.getParamValue('prefixSpace'), 10),
            postfixSpace = !!parseInt(this.props.getParamValue('postfixSpace'), 10),
            socialStats = !!parseInt(this.props.getParamValue('socialStats'), 10),
            includeSummaryTitle = !!parseInt(this.props.getParamValue('includeSummaryTitle'), 10),
            includeSummaryBody = !!parseInt(this.props.getParamValue('includeSummaryBody'), 10),
            constants = this.props.app.config.constants,
            visibleSettings = null;
						// ,
            // postStyles = [
            //     {value: constants.POST_SHARED, label: 'Shared Link'},
            //     {value: constants.POST_TEXT, label: 'Status Update'}
            // ];

        if (this.props.activePanel !== 'advanced') {
            switch (parseInt(this.props.getParamValue('postStyle'), 10)) {
                // case constants.POST_TEXT:
                //     optionFields = (
                //         <div>
                //             {this.props.getPostTitle(postTitle)}
                //             {this.props.getPostBody(postBody)}
                //             {this.props.getPostUrl(postUrl)}
                //         </div>
                //     );
                //     break;

                case constants.POST_SHARED:
                default:
                    optionFields = (
                        <div>
                            {this.props.getIncludeSummaryTitle(includeSummaryTitle)}
                            {this.props.getIncludeSummaryBody(includeSummaryBody)}
                        </div>
                    );
                    break;
            }

            if (this.props.hasInputOverrides) {
                if (this.props.user.detail.routeViewType === this.props.app.config.constants.ROUTE_VIEW_SIMPLE) {
                    visibleSettings = this.props.generateInputOverrideLink();
                } else {
                    visibleSettings = (
                        <div>
                            {this.props.generateInputOverrideWarning()}
                            {/*{this.props.getPostStyles.apply(this, [postStyles])}*/}
                            {optionFields}
                        </div>
                    )
                }
            } else {
                visibleSettings = (
                    <div>
                        {/*{this.props.getPostStyles.apply(this, [postStyles])}*/}
                        {optionFields}
                    </div>
                )
            }

            currentPanel = (
                <div>
                    {visibleSettings}
                    {this.props.getPrefixText(prefixSpace)}
                    {this.props.getPostfixText(postfixSpace)}
                    {this.props.getActiveToggle()}
                    {this.props.getDeleteButton()}
                </div>
            );
        }

        return this.props.getPanelOutput(currentPanel);
    }
};

export default SocialPanelModule(DiscordOptions);
